import type { UserPreferences } from "../types/domain";
export function buttonColors(preferences?: Partial<UserPreferences>) {
 const legacy = preferences?.buttonPalette === "gold" ? "#F4C16A" : preferences?.buttonPalette === "sage" ? "#E5EFE9" : "#124848";
 const valid = (value: string | undefined, fallback: string) => /^#[0-9a-f]{6}$/i.test(value || "") ? value! : fallback;
 return {primary:valid(preferences?.buttonPalette && preferences.buttonPalette!=="theme" ? legacy : preferences?.buttonColor,legacy),secondary:valid(preferences?.secondaryButtonColor,"#F4C16A")};
}
export function buttonTextColor(color:string) {
 const rgb=color.slice(1).match(/../g)!.map(value=>parseInt(value,16)/255).map(value=>value<=.04045?value/12.92:((value+.055)/1.055)**2.4);
 return rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722>.179?"#000000":"#FFFFFF";
}
export function applyButtonColors(preferences?:Partial<UserPreferences>) {
 const colors=buttonColors(preferences),style=document.documentElement.style;
 for(const role of ["primary","secondary"] as const){style.setProperty("--mundely-"+role+"-button",colors[role]);style.setProperty("--mundely-on-"+role+"-button",buttonTextColor(colors[role]));}
}
